<script setup lang="ts">
import { toRef } from "vue";
import { HousingApplication, Workflow } from "~/api";
import { ApplicationWizardStep } from "../types/plusTypes";
import { useHousingAplicationWizard } from "~/YYC_Housing/composables/useHousingApplicationWizard";

const props = defineProps<{
  workflow: Workflow;
  application: HousingApplication;
}>();

const { stepStatusMap, handleGotoStep } = useHousingAplicationWizard(
  props.application,
  toRef(props, "workflow"),
);

const buttonText: {
  [key: string]: string;
} = {
  Draft: "Continue",
  ReadyForReview: "View",
  Submitted: "View",
  "": "View",
};
</script>

<template>
  <div class="ApplicationWorkflow">
    <div class="ApplicationWorkflowHeader">Housing Application</div>

    <div class="ApplicationWorkflowStatus">
      <span>{{
        stepStatusMap[ApplicationWizardStep.ApplicationForm].statusDisplayText
      }}</span>

      <span class="Instructions">
        Click the "Continue" button to fill your application
      </span>
    </div>

    <el-button
      class="ApplicationWorkflowButton"
      type="primary"
      @click="() => handleGotoStep(ApplicationWizardStep.ApplicationForm)"
    >
      {{ buttonText[workflow.status ?? ""] }}
    </el-button>
  </div>
</template>

<style lang="less">
.ApplicationWorkflow {
  grid-area: form;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;

  .ApplicationWorkflowHeader {
    font-weight: 500;
    font-size: 1.25em;
    @media (max-width: 700px) {
      font-size: 1em;
    }
    @media (max-width: 500px) {
      font-size: 0.8em;
    }
  }

  .ApplicationWorkflowStatus {
    justify-self: center;
    font-size: 1.015385em;

    display: flex;
    flex-direction: column;
    align-items: center;
    .Instructions {
      font-size: 0.8em;
    }
    @media (max-width: 700px) {
      font-size: 0.8em;
    }
    @media (max-width: 500px) {
      font-size: 0.6em;
    }
  }

  .ApplicationWorkflowButton {
    width: min-content;
    justify-self: flex-end;
    @media (max-width: 500px) {
      font-size: 10px;
      padding: 4px 10px;
    }
  }
}
</style>
